import React from 'react'
import Slider from 'react-slick'
import LazyLoad from 'react-lazyload'
import { ComponentFactoryConstants } from '../../adapters/helpers/Constants'
import { optimizeImage } from '../../adapters/helpers/pageSpeedHelper'
import ImageFactory from '../../adapters/cloudinary/ImageFactory'
export default function ArticleListCarousel({articles,leftArrowIcon,rightArrowIcon}) {
    const videoSettings = {
        dots: false,
        speed: 1000,
        autoplay: false,
        lazyLoad: true,
        responsive: [
            {
                settings: {
                    dots: false,
                    slidesToShow: 1,
                },
                breakpoint: 992,
            },
        ],
        slidesToShow: 1,
        accessibility: true,
        slidesToScroll: 1,
        nextArrow: <img src={optimizeImage(rightArrowIcon?.fields?.file?.url)} data-action-detail='carousel-next-arrow' alt={'CarouselBlockConstants.rightArrow'} />,
        prevArrow: <img src={optimizeImage(leftArrowIcon?.fields?.file?.url)} data-action-detail='carousel-previous-arrow' alt={'CarouselBlockConstants.leftArrow'} />,
    }
    return (
        <section className='articlelist-carousel'>
            <Slider {...videoSettings} className='ob-oral-care-education-slicker'>
                {articles.map((article, i) => {
                    const overview = article?.fields?.articleOverview
                    const thumbnail = overview?.fields?.thumbnailImage
                    const contentThumbnail = thumbnail?.fields?.asset?.fields?.file?.url
                    return (
                        <a
                            key={i}
                            className='ob-additional-reading__item-link event_internal_link'
                            data-action-detail={overview?.fields?.linkDataActionDetail}
                            href={overview?.fields?.aricleOverviewLink ? overview?.fields?.aricleOverviewLink : overview?.fields?.slug?.fields?.slug}
                        >
                            <div className='ob-additional-reading__item-image'>
                                {!!contentThumbnail && (
                                    <LazyLoad
                                        offset={100}
                                        placeholder={
                                            <picture className='ob-additional-reading__item-pic'>
                                                <img className='ob-additional-reading__item-img' alt={`${overview?.fields?.title}`} height={150} />
                                            </picture>
                                        }
                                    >
                                        <picture className='ob-additional-reading__item-pic'>
                                            <source media={ComponentFactoryConstants.mediaLower} srcSet={optimizeImage(contentThumbnail)} />
                                            <source srcSet={optimizeImage(contentThumbnail)} />

                                            {contentThumbnail && (
                                                <img className='ob-additional-reading__item-img' alt={`${overview?.fields?.title} `} src={optimizeImage(contentThumbnail)} srcSet={optimizeImage(contentThumbnail)} height={150} />
                                            )}
                                        </picture>
                                    </LazyLoad>
                                )}
                            </div>

                            <div className='ob-additional-reading__item-inf'>
                                <div className='ob-additional-reading__item-title'>{overview?.fields?.title}</div>
                                <div className='ob-additional-reading__item-description'>
                                    <p>{overview?.fields?.description}</p>
                                </div>
                                {!!overview?.fields?.readTime && <div className='ob-additional-reading__item-time'>{overview.fields.readTime} min read</div>}
                            </div>
                        </a>
                    )
                })}
            </Slider>
        </section>
    )
}
